import { MEDIA_KIND_LABELS } from "@/shared/config/media"

/** Что прикреплено к блоку: «Видео · с обложкой», «Фото», «Альбом · 3». */
export function attachmentLabel(config: Record<string, unknown> | null | undefined): string | null {
	if (!config) return null
	const { gallery, media } = config
	if (Array.isArray(gallery) && gallery.length > 0) return `Альбом · ${gallery.length}`
	if (media && typeof media === "object") {
		const { kind, cover } = media as { kind?: string; cover?: unknown }
		const label = kind ? MEDIA_KIND_LABELS[kind as keyof typeof MEDIA_KIND_LABELS] : undefined
		if (label) return cover ? `${label} · с обложкой` : label
	}
	return null
}
